import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { LoginService } from "./../login.service";
import { ActivatedRoute, Router } from "@angular/router";
import { take, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-nav",
    templateUrl: "./nav.component.html",
    styleUrls: ["./nav.component.scss"],
    standalone: false
})
export class NavComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();

  code;

  constructor(
    private route: ActivatedRoute,
    public ls: LoginService,
    public router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params["code"]) {
        this.code = params["code"];
        this.ls.login(undefined, undefined, false, false, undefined, this.code);
      } else {
        this.ls.loginMissing();
      }
    });
    this.ls.onFailedLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.router.navigate(["/"]);
    });
  }

  ngAfterViewInit(): void {
    this.ls.onLoginComplete.pipe(takeUntil(this.destroy$)).subscribe(() => {
      const rawLang = this.ls.premissions?.interfaceLanguages;
      this.ls
        .setInterfaceLanguage(rawLang)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.checkAndNavigate();
          },
          error: () => {
            console.warn(`Failed to load "${rawLang}", falling back to English.`);
            this.ls
              .setInterfaceLanguage("English")
              .pipe(take(1))
              .subscribe(() => this.checkAndNavigate());
          },
        });
    });
  }

  checkAndNavigate() {
    if (this.ls.premissions?.Appointments) {
      this.router.navigate(["/appointments"]);
    }
    if (this.ls.premissions?.Billings && !this.ls.premissions?.Appointments) {
      this.router.navigate(["/billing"]);
    }
    if (this.ls.premissions?.Questionnaires && !this.ls.premissions?.Appointments && !this.ls.premissions?.Billings) {
      this.router.navigate(["/questionnaires"]);
    }
    if (this.ls.premissions?.FinancialReports && !this.ls.premissions?.Appointments && !this.ls.premissions?.Billings && !this.ls.premissions?.Questionnaires) {
      this.router.navigate(["/financial"]);
    }
    return;
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
